import type { Gun } from "../entities/gun";
import { isMuted } from "../audio";
import { view, HUD_SCALE as S } from "../viewport";

// Heads-up display. Phase 5: thin shell icons in the top-right corner with a
// slim reload bar directly beneath them (no text, no numeric count).
// Score / wave / combo are added in Phase 8.
export function addHud(gun: Gun, getElapsed: () => number) {
  const hud = add([z(120), fixed()]);

  const shellW = 6 * S;
  const shellH = 14 * S;
  const gap = 4 * S;
  const pitch = shellW + gap;

  hud.onDraw(() => {
    const mag = gun.magazineSize();
    const loaded = gun.shells();
    const rowW = mag * shellW + (mag - 1) * gap;
    const startX = view.right - 10 - rowW; // top-right of the visible region
    const y = view.top + 10;

    // survived time (m:ss), to the left of the ammo
    const secs = Math.floor(getElapsed());
    const time = `${Math.floor(secs / 60)}:${(secs % 60).toString().padStart(2, "0")}`;
    drawText({ text: time, size: 10 * S, font: "press2p", pos: vec2(startX - 8, y + 2), anchor: "topright", color: rgb(255, 233, 168) });

    // thin shell icons (top-right)
    for (let i = 0; i < mag; i++) {
      const x = startX + i * pitch;
      const lit = i < loaded;
      drawRect({ pos: vec2(x, y), width: shellW, height: shellH, color: lit ? rgb(184, 31, 31) : rgb(38, 28, 28) });
      drawRect({ pos: vec2(x, y + shellH - 5 * S), width: shellW, height: 5 * S, color: lit ? rgb(224, 165, 42) : rgb(58, 48, 30) });
      if (lit) drawRect({ pos: vec2(x, y), width: shellW, height: 2 * S, color: rgb(232, 96, 96) });
    }

    // slim reload bar directly under the shells (only while reloading)
    if (gun.isReloading()) {
      const bh = 4 * S;
      const by = y + shellH + 3 * S;
      drawRect({ pos: vec2(startX, by), width: rowW, height: bh, color: rgb(12, 10, 20) });
      drawRect({ pos: vec2(startX, by), width: rowW * gun.reloadProgress(), height: bh, color: rgb(224, 165, 42) });
    } else if (isMuted()) {
      // mute indicator (where the reload bar would be)
      drawText({ text: "MUTED", size: 8 * S, font: "press2p", pos: vec2(view.right - 10, y + shellH + 4), anchor: "topright", color: rgb(150, 150, 150) });
    }
  });

  return hud;
}
